// extracted by mini-css-extract-plugin
export default {"disc":"_2N92F"};